<template>
  <div>
    <button
      class="btn btn-primary btn-sm"
      data-toggle="tooltip"
      data-placement="top"
      title="Email quote"
      @click="fnShowModal()"
    >
      Email Quote
    </button>

    <b-modal ref="userModal" hide-footer title="Email quote to client">
      <div class="d-block">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                id="clientName"
                placeholder=" "
                autocomplete="off_clientName"
                v-model="clientName"
              />
              <label class="floatingLabel" for="clientName">Client name</label>
              <!-- <div class="invalid-feedback" v-if="errors.firstName">{{ errors.firstName[0] }}</div> -->
            </div>
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                id="clientEmail"
                placeholder=" "
                autocomplete="off_clientEmail"
                v-model="clientEmail"
              />
              <label class="floatingLabel" for="clientEmail"
                >Client email</label
              >
            </div>
            <!-- For Admin/Staff -->
            <div
              class="form-group multiselect"
              v-if="userData.role_id == 1 || userData.role_id == 2"
            >
              <multiselect
                v-model="objDealer"
                :options="getDealerDropdown"
                placeholder=""
                label="name"
                track-by="name"
              >
              </multiselect>
              <label class="typo__label floatingLabel">Dealer</label>
            </div>
            <!-- For Dealer and his belongs -->

            <div class="form-group multiselect" v-if="userData.role_id == 4">
              <multiselect
                v-model="objDealer"
                :options="getDealersWhichBelongsToUser"
                placeholder=""
                label="name"
                track-by="name"
              >
              </multiselect>
              <label class="typo__label floatingLabel">Dealer</label>
            </div>
            <div class="form-group multiselect">
              <multiselect
                v-model="objDealerStaff"
                :options="getDealerStaffDropdown"
                placeholder=""
                label="name"
                track-by="name"
              >
              </multiselect>
              <label class="typo__label floatingLabel">Dealer staff</label>
            </div>
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                id="position"
                placeholder=" "
                autocomplete="off_position"
                v-model="dealerStaffEmail"
                disabled
              />
              <label class="floatingLabel" for="position">Dealer email</label>
            </div>
          </div>
        </div>
        <hr />
        <div class="text-right">
          <button
            type="button"
            class="btn btn-dark btn-sm mr-2"
            @click="hideModal"
          >
            Cancel
          </button>
          <button
            type="button"
            @click="fnSendQuote()"
            class="btn btn-primary btn-sm"
          >
            <b-spinner small v-if="is_spinActive"></b-spinner>
            Send
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Multiselect from 'vue-multiselect'
import * as authService from '../../services/auth.service'
import * as messageService from '../../services/message.service'
import * as quoteCalculationService from '../../services/quoteCalculation.service'
import * as quoteService from '../../services/quote.service'

export default {
  name: 'ModelQuoteEmailOption',
  props: {
    propsData: {
      type: Object,
      required: true
    },
    quoteType: {
      type: String,
      required: true
    }
  },
  components: {
    Multiselect
  },
  data() {
    return {
      quoteId: this.$route.params.quoteId,
      errors: {},
      objQuoteCalculation: {},
      clientName: '',
      clientEmail: '',
      objDealer: {},
      objDealerStaff: '',
      dealerStaffEmail: '',
      dealerId: '',
      dealerStaffId: '',
      is_spinActive: false,
      getDealersWhichBelongsToUser: [],
      userData: ''
    }
  },
  computed: {
    ...mapGetters([
      'getDealerDropdown',
      'getDealerStaffDropdown',
      'getUserById'
    ])
  },
  methods: {
    ...mapActions([
      'fetchDealerDropdown',
      'fetchDealerStaffDropdown',
      'fetchUserById'
    ]),
    fnShowModal() {
      this.fnQuoteCalculation()
      this.showModal()
    },
    hideModal() {
      this.$refs.userModal.hide()
    },
    showModal() {
      this.$refs.userModal.show()
    },
    fnQuoteCalculation() {
      let quoteCalculation = quoteCalculationService.calculation1(
        this.quoteType,
        this.quoteId,
        this.propsData
      )
      this.objQuoteCalculation = quoteCalculation

      this.clientName = this.objQuoteCalculation.clientFullName
      this.clientEmail = this.objQuoteCalculation.clientEmail
      this.objDealer = {
        id: this.objQuoteCalculation.dealerId,
        name: this.objQuoteCalculation.dealerName
      }
    },

    /**
     * For quote/leads quote sending we use same method
     */

    fnSendQuote: async function () {
      this.objQuoteCalculation.clientFullName = this.clientName
      this.objQuoteCalculation.clientEmail = this.clientEmail
      this.objQuoteCalculation.dealerName = this.objDealer.name
      this.objQuoteCalculation.createdUserEmail = this.dealerStaffEmail
      this.objQuoteCalculation.createdUserName = this.objDealerStaff.name
      this.objQuoteCalculation.createdUserMobNumber = this.objDealerStaff.mobile

      try {
        this.is_spinActive = true
        const response = await quoteService.sendPdfQuote(
          JSON.stringify(this.objQuoteCalculation)
        )
        this.is_spinActive = false
        this.hideModal()
        messageService.fnSweetAlertSuccessToast(
          'Email quote',
          'Sent successfully'
        )
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break
          case 500:
            messageService.fnSweetAlertErrorToast(
              'Email quote - new',
              error.response.data.message
            )
            break
          default:
            messageService.fnSweetAlertErrorToast(
              'Email quote - new',
              'Something wrong'
            )
            break
        }
      }
    }
  },
  created() {
    this.fetchDealerDropdown()
    this.userData = authService.getUserFromToken()
    this.fetchUserById(this.userData.id)
  },
  watch: {
    objDealer: function (val) {
      this.objDealerStaff = ''
      this.dealerStaffEmail = ''

      this.fetchDealerStaffDropdown(val.id)
    },
    objDealerStaff: function (val) {
      this.dealerStaffEmail = ''
      this.dealerStaffEmail = val.email
    },

    getUserById(val) {
      this.getDealersWhichBelongsToUser = val.dealers
    }
  }
}
</script>
